var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-container',[_c('avue-form',{ref:"form",attrs:{"option":_vm.option,"upload-before":_vm.uploadBefore,"upload-after":_vm.uploadAfter},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }